import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // You could also log to a logging service
    console.error('Unhandled UI Error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, maxWidth: 600, margin: '40px auto', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h2>Something went wrong.</h2>
          <p style={{ color: '#666', marginBottom: 20 }}>Please try refreshing the page or navigating back to the home page.</p>
          <a
            href="/v2"
            style={{
              display: 'inline-block',
              padding: '10px 20px',
              backgroundColor: '#1f6f78',
              color: '#fff',
              textDecoration: 'none',
              borderRadius: 6,
              fontWeight: 600
            }}
          >
            Return to Home
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
